export default __webpack_public_path__ + "static/media/MBTorpedoClosed.5eec30c7.jpg";